import { render } from "./ActionIncident.vue?vue&type=template&id=45e44af5"
import script from "./ActionIncident.vue?vue&type=script&lang=js"
export * from "./ActionIncident.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__